// extracted by mini-css-extract-plugin
module.exports = {"l1spvexa":"l1spvexa","left":"left","right":"right"};